import { match } from "ts-pattern";
import {
  BannerFormSubmit,
  BannerLimitFreeUsage,
  BannerRunModelOnPlaygroundDotCom,
} from "./banners";
import { usePlaygroundContext } from "./context";

export function InputFormFooter({
  disabled,
  isAuthenticated,
  isLoading,
  modelRunnableOnPlaygroundDotCom,
  onReset,
  submitLabel = "Run",
  isOfficial = false,
}: {
  disabled: boolean;
  isAuthenticated: boolean;
  isLoading: boolean;
  modelRunnableOnPlaygroundDotCom: boolean;
  onReset: () => void;
  submitLabel?: string;
  isOfficial?: boolean;
}) {
  const { version } = usePlaygroundContext();

  const conditions = {
    disabled,
    modelRunnableOnPlaygroundDotCom,
  };

  return (
    <div className="sticky bottom-[-4px] bg-white">
      {match(conditions)
        .with(
          {
            disabled: true,
            modelRunnableOnPlaygroundDotCom: true,
          },
          () => <BannerRunModelOnPlaygroundDotCom />
        )
        .with(
          {
            disabled: true,
          },
          () => (
            <BannerLimitFreeUsage
              isAuthenticated={isAuthenticated}
              // Hack: version._extras.prediction_price_for_principal refers to a version
              // that doesn't belong to the official model (because shadow models are used
              // for official models). So logic.model_is_official(obj.model) is false for it.
              // As a result, we hide the unit price from displaying in the banner for official models.
              unitPrice={
                isOfficial
                  ? null
                  : version._extras.prediction_price_for_principal
              }
            />
          )
        )
        .with(
          {
            disabled: false,
          },
          () => (
            <BannerFormSubmit
              disabled={disabled}
              isLoading={isLoading}
              onReset={onReset}
              submitLabel={submitLabel}
            />
          )
        )
        .exhaustive()}
    </div>
  );
}
